import { gameStage } from '@/models/fixture';

export type TournamentStageTabId = 'groupStage' | 'roundOf32' | 'roundOf16' | 'finals';

export const TOURNAMENT_STAGE_TABS: {
  id: TournamentStageTabId;
  label: string;
  shortLabel: string;
  stages: gameStage[];
}[] = [
  { id: 'groupStage', label: 'Group Stage', shortLabel: 'Group Stage', stages: [gameStage.groupStage] },
  { id: 'roundOf32', label: 'Round of 32', shortLabel: 'R32', stages: [gameStage.roundOf32] },
  { id: 'roundOf16', label: 'Round of 16', shortLabel: 'R16', stages: [gameStage.roundOf16] },
  {
    id: 'finals',
    label: 'Finals',
    shortLabel: 'Finals',
    stages: [
      gameStage.quarterFinal,
      gameStage.semiFinal,
      gameStage.thirdPlayoff,
      gameStage.final,
    ],
  },
];

export function tabIdForStage(stage: gameStage): TournamentStageTabId | null {
  const tab = TOURNAMENT_STAGE_TABS.find((t) => t.stages.includes(stage));
  return tab?.id ?? null;
}

export function tabIndexForStage(stage: gameStage): number | null {
  const tabId = tabIdForStage(stage);
  if (tabId === null) return null;
  const index = TOURNAMENT_STAGE_TABS.findIndex((t) => t.id === tabId);
  return index >= 0 ? index : null;
}
